import { getRandomIntegerFromInterval } from '../../utils';
import { generateReservationsEvents } from '../Amenity/utils';

import { CALENDAR_VIEW_OPTIONS } from './constants';

export const generateSkeletonCalendarPlaceholders = ({
  date_after,
  date_before,
}) => {
  const startTime = Date.parse(date_after);
  const endTime = Date.parse(date_before);
  const dates = [];
  for (let i = 0; i < 60; i += 1) {
    dates.push(getRandomIntegerFromInterval(startTime, endTime));
  }
  const placeholders = generateReservationsEvents(dates);
  return placeholders;
};

export const getSelectedView = (isXs, isSm, isLg) => {
  if (isLg) return CALENDAR_VIEW_OPTIONS.month;
  if (isSm) return CALENDAR_VIEW_OPTIONS.week;
  if (isXs) return CALENDAR_VIEW_OPTIONS.day;
  return CALENDAR_VIEW_OPTIONS.month;
};
